<template>
	<div v-loading='loading'>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" style="margin-bottom:100px"
			class="demo-ruleForm">
			<div style="background: #fff;padding:0 0 15px;margin-top: 10px;"
				v-for="(item, index) in ruleForm.modeConfig" :key="index">
				<div style="background: #DCDFE6;padding: 10px 15px;margin-bottom: 15px;">级别{{ numberFormat[index] }}
					{{ item.AgentRoleGradeNum == 1 ? '（最高级别）' : ((index == ruleForm.modeConfig.length - 1) ? '（最低级别）' : '') }}
				</div>
				<el-form-item label="级别名称" prop="AgentRoleName" :rules="rules.AgentRoleName"
					:prop="'modeConfig.' + index + '.AgentRoleName'">
					<el-input v-model="item.AgentRoleName" placeholder="最多输入10个字" size="small" maxlength="10"
						style="width: 400px;"></el-input>
				</el-form-item>
				<div class="blueBox" v-if='index == 0'>
					<div>升级说明：</div>
					<div>1.可前往升级统计页面，考核各推手升级指标，并为达到指标的推手进行手动升级为最高级别推手。
						<el-button type="text" @click='toUpStatistics'>点击前往升级统计页面</el-button>
					</div>
				</div>
				<div v-if='index == 1'>
					<el-form-item label="升级条件(或)" :rules="rules.nocheck">
						<div style="display: inline-block;margin-bottom:20px"
							v-for="(v, i) in item.TianXianAgentRoleUpRuleDtos">
							<el-checkbox v-model="v.IsOpen" style="margin: 0 15px;"></el-checkbox>
							<span>{{ i == 0 ? 1 : '连续3' }}个自然月，累计直接推荐平级 </span>
							<el-form-item class="allOrderCountStyle" style="display: inline-block;"
								:rules="v.IsOpen ? rules.TotalRecommendCount : rules.nocheck"
								:prop="'modeConfig.' + index + '.TianXianAgentRoleUpRuleDtos.' + i + '.TotalRecommendCount'">
								<el-input v-model="v.TotalRecommendCount"
									onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
									onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
									style="width: 100px;margin: 0 10px;" key="TotalRecommendCount"></el-input>
								人，且个人业绩+直推业绩≥
							</el-form-item>
							<el-form-item class="allOrderCountStyle" style="display: inline-block;width:220px"
								:rules="v.IsOpen ? rules.MyAndRecPerformanceMoney : rules.nocheck"
								:prop="'modeConfig.' + index + '.TianXianAgentRoleUpRuleDtos.' + i + '.MyAndRecPerformanceMoney'">
								<el-input v-model="v.MyAndRecPerformanceMoney"
									oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))"
									style="width: 100px;margin: 0 10px;" key="MyAndRecPerformanceMoney"></el-input>
								元
							</el-form-item>
						</div>
					</el-form-item>
					<div class="blueBox">
						<div>升级条件说明：</div>
						<div>1.升级条件：升级至级别二需要达到的条件</div>
						<div>2.升级条件可选择多个，多个条件间关系为“或”，即达到选中的任一条件，次月1号即可完成升级</div>
						<div>3.业绩=推手个人销售业绩+直推推手个人销售业绩；业绩在订单支付成功后，按订单实付金额(不含运费)计入；订单产生退款，将剔除退款成功部分</div>
					</div>
				</div>
				<el-form-item label="授权条件" :rules="rules.nocheck" v-if="index == 2">
					<div>
						<span style="margin-left:15px;margin-right: 15px;">普通客户升级到最低级别，前往推手模式配置页，选择成为推手的条件。</span>
						<el-button type="text" @click='toPushgoodlist'>点击前往配置加入条件</el-button>
					</div>
				</el-form-item>


			</div>
		</el-form>
		<div class="bottom-save-btn">
			<el-button type="primary" style="width:240px" @click="submitForm('ruleForm')"
				:loading="saveLoading">保存</el-button>
		</div>
	</div>
</template>
<script>
import {
	tianXianAgentRolelist,
	tianXianAgentRolesave,

} from '@/api/TurnTomySelf.js';
import {
	malldriverRecruitmentConfig,
} from '@/api/sv3.0.0';

import config from '@/config/index'

export default {
	data() {
		var checkno = (rule, value, callback) => {
			return callback();
		};
		var AllTeamOrderCountCheck = (rule, value, callback) => {
			if (!String(value) || value < 0 || value > 99999) {
				return callback(new Error('人数请设置在0~99999之间，整数'));
			} else {
				return callback();
			}
		}
		var MyAndRecPerformanceMoneyCheck = (rule, value, callback) => {
			let two = /^\d+(\.\d{1,2})?$/
			if (!String(value) || value < 0 || value > 9999999 || !two.test(value)) {
				return callback(new Error('业绩请设置在0~9999999之间，2位小数'));
			} else {
				return callback();
			}
		}
		return {
			saveLoading: false,
			loading: false,
			numberFormat: ['一', '二', '三'],
			ruleForm: {
				modeConfig: [{
					Id: 0,
					AgentRoleName: '',
					AgentRoleGradeNum: 1,
					TianXianAgentRoleUpRuleDtos: [],
				}]
			},
			rules: {
				nocheck: [{
					validator: checkno,
					required: true,
					trigger: 'change'
				}],
				AgentRoleName: [{
					required: true,
					message: '请填写级别名称',
					trigger: 'blur'
				}, {
					min: 1,
					max: 10,
					message: '最多输入10个字',
					trigger: 'blur'
				}],
				TotalRecommendCount: [{
					required: true,
					validator: AllTeamOrderCountCheck,
					trigger: 'blur'
				}],
				MyAndRecPerformanceMoney: [{
					required: true,
					validator: MyAndRecPerformanceMoneyCheck,
					trigger: 'blur'
				}],
			},
			result: {}
		}
	},
	mounted() {
		this.getagentConfig()
	},
	methods: {
		defaultList() {
			return [
				{
					Id: 0,
					AgentRoleId: 0,
					IsOpen: false,
					UpRuleMonthType: 0,
					TotalRecommendCount: '',
					MyAndRecPerformanceMoney: '',
				},
				{
					Id: 0,
					AgentRoleId: 0,
					IsOpen: false,
					UpRuleMonthType: 0,
					TotalRecommendCount: '',
					MyAndRecPerformanceMoney: '',
				},
			]
		},
		toPushgoodlist() {
			let headsUrls = process.env.NODE_ENV == 'production' ? 'index.html#' : ''
			let url = config.GO_URL + headsUrls + '/agent/driverrecruiting';
			window.open(url)
			// this.$router.push({
			// 	path: '/agent/driverrecruiting'
			// });
		},
		toUpStatistics() {
			let headsUrls = process.env.NODE_ENV == 'production' ? 'index.html#' : ''
			let url = config.GO_URL + headsUrls + '/agent/upStatistics';
			window.open(url)
			// this.$router.push({
			// 	path: '/agent/upStatistics'
			// });
		},
		async getagentConfig() {
			try {
				this.loading = true
				let result = await tianXianAgentRolelist({})
				if (result.IsSuccess) {
					if (result.Result && result.Result.length) {
						this.ruleForm.modeConfig = result.Result.map((v, i) => {
							if (i == 1 && (!v.TianXianAgentRoleUpRuleDtos || !v.TianXianAgentRoleUpRuleDtos.length)) {
								v.TianXianAgentRoleUpRuleDtos = this.defaultList()
							}
							return v
						})
					}
					console.log(this.ruleForm.modeConfig)
				}
			} catch (err) {

			} finally {
				this.loading = false
			}
		},
		// 保存
		submitForm(formName) {
			this.$refs[formName].validate(async (valid) => {
				if (valid) {
					try {
						this.saveLoading = true
						let ruleForm = JSON.parse(JSON.stringify(this.ruleForm))

						let list = ruleForm.modeConfig[1]
						if (!list.TianXianAgentRoleUpRuleDtos.filter(v => v.IsOpen).length) {
							this.$message.error('请选择升级条件')
							return
						}
						ruleForm.modeConfig[1].TianXianAgentRoleUpRuleDtos = ruleForm.modeConfig[1].TianXianAgentRoleUpRuleDtos.map((v, i) => {
							v.UpRuleMonthType = i + 1
							return v
						})
						let data = {
							AgentRoleList: ruleForm.modeConfig
						}
						let result = await tianXianAgentRolesave(data)
						if (result.IsSuccess) {
							this.$message({
								showClose: true,
								type: 'success',
								message: '操作成功!'
							});
							this.getagentConfig()
							setTimeout(() => {
								this.saveLoading = false; //响应后延迟几秒回复正常；
							}, 2500)

						}


					} catch (e) {
						//TODO handle the exception
						console.log(e)
					} finally {

						this.saveLoading = false
					}


				} else { }
			});

		},
	}
}
</script>
<style lang="less" scoped>
.flex {
	display: flex;
}

.blueBox {
	border: 1px solid #409EEF;
	padding: 15px 100px 15px 15px;
	margin: 50px 15px 15px 25px;

	div {
		font-size: 14px;
		color: #606266;
		line-height: 1.7;
	}
}

.allOrderCountStyle {
	::v-deep .el-form-item__error {
		margin-left: 10px;
		width: 100%;
	}
}

.aMyAndRecPerformanceMoneyStyle {
	::v-deep .el-form-item__error {
		margin-left: 99px;
		width: 100%;
	}
}

.singleOrderCountStyle {
	::v-deep .el-form-item__error {
		margin-left: 75px;
		width: 100%;
	}
}

.bottom-save-btn {
	position: fixed;
	width: 100%;
	background: #fff;
	bottom: 0;
	text-align: center;
	padding: 20px 0;
	z-index: 100;
	box-shadow: 13px 1px 6px #999;
}

input[type=number]::-webkit-inner-spin-button {
	-webkit-appearance: none;
}
</style>
